// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import SupportIcon from './assets/support-icon.svg';
import S from './style';
import { Formik } from 'formik';
import DragField from './DragField';
import { sendQuestionnaire } from './hook';

interface ImageUpload {
  content: string;
  contentType: string;
  file: File;
  name: string;
}

const QuestionnairePage = (props: any): JSX.Element => {
  const basicInfo = props.basicInfo;
  const setShowQuestionnaire = props.setShowQuestionnaire;

  const intl = useIntl();
  const [sent, setSent] = useState(false);
  const [listImagePreviewUrls, setListImagePreviewUrl] = useState<ImageUpload[]>([]);
  const [displayDragField, setDisplayDragField] = useState<boolean>(false);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [errorText, setErrorText] = useState('');

  function validate(values: any) {
    const errors: any = {};
    if (values.message === '' && rating < 4) {
      errors.message = 'Required';
    }
    return errors;
  }

  const dragOver = (e: any) => {
    e.preventDefault();
    // setDisplayDragField(false)
  }

  const dragEnter = (e: any) => {
    e.preventDefault();
    setDisplayDragField(true);
  }

  const dragLeave = (e: any) => {
    e.preventDefault();
    // setDisplayDragField(false)
  }

  const imagePreview = (file: File) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const acceptType = ['image/png', 'image/svg+xml', 'image/gif', 'image/jpeg', 'image/jpg'];
      if (listImagePreviewUrls.length < 5) {
        setErrorText('');
        if (acceptType.includes(file.type)) {
          const url = reader.result as string;
          setListImagePreviewUrl(data => [...data, { content: url, file, name: file.name, contentType: file.type }])
        }
      } else {
        setErrorText('I032');
      }
    };
  }

  const fileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer) {
      const files = e.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        imagePreview(files[i])
      }
    }
    setDisplayDragField(false)
    // console.log(files);
  }

  return (
    <Formik
      initialValues={{
        message: '',
      }}
      onSubmit={async (fields, { setFieldValue }) => {
        try {
          const payload = {
            memberId: basicInfo.memberId,
            score: rating,
            sourceId: basicInfo.sourceId,
            sourceFrom: basicInfo.sourceFrom,
            handsOnType: basicInfo.handsOnType,
            handsOnId: basicInfo.handsOnId,
            handsOnRecordId: basicInfo.handsOnRecordId,
            comment: fields.message,
            picture: listImagePreviewUrls.map((item) => {
              return { name: item.name, content: item.content, contentType: item.contentType }
            })
          }
          sendQuestionnaire(payload);
        } catch (e) {
          console.log(e);
        }
        setFieldValue('message', '');
        setListImagePreviewUrl([]);
        setSent(true);
        setShowQuestionnaire(false);
      }}
      validate={validate}
    >
      {({
        values,
        handleChange,
        handleSubmit,
        handleBlur
      }) => (
        <S.Form onSubmit={handleSubmit} autoComplete="off" {...props}>
          <S.Wrapper
            onDragOver={dragOver}
            onDragEnter={dragEnter}
            onDragLeave={dragLeave}
            onDrop={fileDrop}
          >
            <S.Banner/>
            {displayDragField && <DragField />}
            <S.NewSupportField >
              <S.NewSupportFieldHeaderWrapper>
                <S.NewSupportFieldHeaderIcon src={SupportIcon} />
                <S.NewSupportFieldTitle><FormattedMessage id="I029" /></S.NewSupportFieldTitle>
                <S.NewSupportFieldText><FormattedMessage id="I030" /></S.NewSupportFieldText>
              </S.NewSupportFieldHeaderWrapper>
              <S.RateContainer>
                <S.RateTitle><FormattedMessage id="I028" /></S.RateTitle>
                {[...Array(5)].map((star, index) => {
                  index += 1;
                  return (
                    <S.starBtn
                      type="button"
                      key={index}
                      active={index <= (hover || rating)}
                      onClick={() => setRating(index)}
                      onMouseEnter={() => setHover(index)}
                      onMouseLeave={() => setHover(rating)}
                    >
                      <S.star>&#9733;</S.star>
                    </S.starBtn>
                  );
                })}
                { rating !== 0 && rating < 4 ? <S.RatingText><FormattedMessage id={'I033'} /></S.RatingText> : null }
              </S.RateContainer>
              <S.ReplyField
                message={values.message}
                placeholder={intl.formatMessage({ id: 'I027' })}
                onChange={handleChange}
                onBlur={handleBlur}
                listImagePreviewUrls={listImagePreviewUrls}
                setListImagePreviewUrl={setListImagePreviewUrl}
                errorText={errorText}
                setErrorText={setErrorText}
                disabled={(rating < 4 && !values.message) || rating === 0}
              />
            </S.NewSupportField>
          </S.Wrapper>
        </S.Form>
      )
      }
    </Formik >
  );
}

export { QuestionnairePage as default }
